/* Which palette the board draws in.
 *
 * Three states, because the stylesheet already carries three: no attribute
 * follows the operating system, and "light" or "dark" pins it whatever the
 * system says. warroom.css has had the `[data-theme]` selectors since it
 * was lifted from the single-file build — the control was simply never
 * wired to them, so nothing in the design system changes here.
 *
 * The choice is a per-browser convenience rather than something the board
 * needs to know, so localStorage is its right home. Every access is
 * guarded: a browser with site data blocked throws on read rather than
 * answering null, and a theme that cannot be remembered should still
 * apply for the tab it was chosen in. */

export const STORAGE_KEY = "warroom-theme";
const ORDER = ["system", "light", "dark"];

export function readTheme() {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    return v === "light" || v === "dark" ? v : "system";
  } catch {
    return "system";
  }
}

export function applyTheme(theme) {
  const root = document.documentElement;
  if (theme === "light" || theme === "dark") {
    root.setAttribute("data-theme", theme);
  } else {
    root.removeAttribute("data-theme");
  }
  try {
    if (theme === "system") localStorage.removeItem(STORAGE_KEY);
    else localStorage.setItem(STORAGE_KEY, theme);
  } catch {
    /* Nothing to do — the attribute is set either way. */
  }
}

export function nextTheme(theme) {
  return ORDER[(ORDER.indexOf(theme) + 1) % ORDER.length];
}

/* What is actually on screen right now. Dark is the base palette and light
   is the swap, so "system" resolves the same way the stylesheet does. */
export function resolveTheme(theme) {
  if (theme === "light" || theme === "dark") return theme;
  return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
}
